import { format } from 'date-fns'
import DateUtils from '@/utils/date'

/**
 * 将日期时间转换成中文12小时制
 */
export function formatDate12CN(date) {
  return format(
    new Date(DateUtils.safeDate(date)),
    'yyyy年MM月dd日 aaa hh时mm分'
  )
    .replace(' am ', '上午')
    .replace(' pm ', '下午')
}

export function getParagraphHtml(content, textIndent = '2em') {
  return `<p class="section-paragraph" style="font-size: 16px; line-height: 1.5; padding: 5px; text-indent: ${textIndent};">${content}</p>`
}

export function getSectionHtml(title, paragraphList) {
  const sectionBody = paragraphList.join('')
  if (title) {
    return `
    <div class="section">
      <h3 class="section-title" style="font-size: 21px; margin: 24px 0;">${title}</h3>
      ${sectionBody}
    </div>
    `
  }
  return `<div class="section">${sectionBody} </div>`
}

export function getSectionSignHtml() {
  return `<div class="section-sign" style="margin-top: 80px;">
            <span>全体评审专家签字：</span>
            【签名区域】
          </div>`
}

export function getSectionDateHtml(date) {
  return `<div class="section-date" style="margin-top: 24px; text-align: right;">${date}</div>`
}

export function getPageHtml(title, bodyHtml) {
  return `
    <div class="page" style="page-break-after: always">
      <h2 class="page-title" style="font-size: 29px; text-align: center;">${title}</h2>
      ${bodyHtml}
    </div>
  `
}

export function getTdHtml(cell) {
  return `<td style="text-align: center; ${cell.style}">${cell.content}</td>`
}

export function getTrHtml(tdList) {
  return `<tr style="text-align: center;">${tdList.join('')}</tr>`
}

export function getThHtml(cell) {
  return `<th style="${cell.style}">${cell.content}</th>`
}

export function getTableHtml(head, body) {
  const headHtml = getTrHtml(head.map(item => getThHtml(item)))
  const bodyHtml = body.map(row => {
    return getTrHtml(row.map(cell => getTdHtml(cell)))
  })
  return `
    <table border="1" cellspacing="0" cellpadding="10">
      <thead>${headHtml}</thead>
      <tbody>${bodyHtml}</tbody>
    </table>
  `
}

export function getDescItemHtml(config) {
  return `
  <div class="desc-item" style="width: 500px; line-height: 1.5; margin-bottom: 30px; font-size: 21px;">
    <div class="desc-label" style="white-space: nowrap; float: left;">${config.label}：</div>
    <div class="desc-value" style="margin-left: 100px;">${config.content}</div>
  </div>
  `
}

export function getDescGroupHtml(descList) {
  const descBody = descList.map(config => getDescItemHtml(config)).join('')
  return `
    <div class="desc-group" style="width: 400px; margin: 0 auto; text-align: left;">
      ${descBody}
    </div>
  `
}

/**
 * 项目封面信息
 * @typedef ProjectCover
 * @property {string} projectName 项目名称
 * @property {string} projectCode 项目编号
 * @property {string} purchaseCompanyName 代理机构
 * @property {string} ownerCompanyName 采购机构
 * @property {string} reviewEndTime 评审结束时间
 * @property {boolean} isAgency 是否是代理机构
 */

/**
 * 获取报告封面
 * @param {ProjectCover} projectInfo 项目信息
 * @param {string} title 报告名称
 * @returns {string}
 */
export function getReportCoverHtml(
  projectInfo,
  title = '评审报告',
  needSign = false
) {
  const coverDescList = [
    { label: '项目名称', content: projectInfo.projectName },
    { label: '项目编号', content: projectInfo.projectCode }
  ]
  if (projectInfo.isAgency) {
    coverDescList.push({
      label: '代理机构',
      content: projectInfo.purchaseCompanyName
    })
  }
  coverDescList.push({
    label: '招标单位',
    content: projectInfo.ownerCompanyName
  })
  const descGroup = getDescGroupHtml(coverDescList)

  const createDate = format(
    new Date(DateUtils.safeDate(projectInfo.reviewEndTime)),
    'yyyy年MM月dd日'
  )

  const signHtml = needSign ? getSectionSignHtml() : ''
  return `
    <div class="page cover" style="page-break-after: always; padding-top: 48px;">
      <h1 class="cover-title" style="margin-bottom: 124px; text-align: center; font-size: 56px;">${title}</h1>
      ${descGroup}
      <div class="cover-footer" style="margin-top: 260px; font-size: 21px; text-align: center;">${createDate}</div>
      ${signHtml}
    </div>
  `
}

export function getReportInHtmlTag(bodyHtml) {
  return `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Document</title>
      <style>
        @page {
          size: A4;
          margin: 10%;

          @bottom-center {
            content: "第" counter(page) "页/共 " counter(pages) "页";
            font-family: SimSun;
            font-size: 12px;
            color: #000;
          }
        }

        body {
          margin: 0;
          padding: 0;
          font-family: SimSun !important;
        }

        span {
          font-family: SimSun !important;
        }

        table tr td {
          text-align: center;
        }
      </style>
    </head>

    <body>${bodyHtml}</body>
  </html>
  `
}
